import { render, staticRenderFns } from "./MedicalRecordsRelease.vue?vue&type=template&id=5f51ff1b"
import script from "./MedicalRecordsRelease.vue?vue&type=script&lang=js"
export * from "./MedicalRecordsRelease.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports